export default __webpack_public_path__ + "static/media/lord-surya.e9632041.jpg";